/**
 * @author    Odessa Team (odessateam@ab-soft.net)
 * @category  Ringcentral
 * @copyright Copyright (c) 2012-2019, RingCentral, Inc. (http://www.ringcentral.com)
 */
import TrustSiteApiService from "@dashboard/ajax/TrustSiteApiService";
import RestClientWithStatusedResponse from "@signup/ajax/RestClientWithStatusedResponse";

/**
 * Describes Trust Site API interface.
 */
export default class TrustSiteApi
{
    /** Trust Site Service API */
    private readonly apiService: TrustSiteApiService;

    /**
     * Constructor.
     *
     * @param baseUrl Trust Site API base URL.
     */
    constructor(baseUrl: string = "/api/1.0/")
    {
        const rest = new RestClientWithStatusedResponse(baseUrl);
        this.apiService = new TrustSiteApiService(rest);
    }

    /** Provides access to the Trust Site Service API */
    public service(): TrustSiteApiService
    {
        return this.apiService;
    }
}

/**
 * Describes Trust Site API request result.
 */
export interface TrustSiteApiRequestResult
{
    [id: string]: any;
}
